import { useState } from "react";
function useFlashInputFocus() {
  const [inputHasFocus, setInputHasFocus] = useState(!1);
  function onInputFocus() {
    setInputHasFocus(!0);
  }
  function onInputBlur() {
    setInputHasFocus(!1);
  }
  return { inputHasFocus, onInputFocus, onInputBlur };
}
export {
  useFlashInputFocus
};
//# sourceMappingURL=useFlashInputFocus.js.map
